<script setup lang="ts">
import { ref } from 'vue'

import type { MediaImageProps } from '@fondof-ui/components/media/types'
import { useImage } from '@fondof-ui/composables/media/useImage'
import type { HTMLAttributeClass } from '@fondof-ui/types'

type Props = MediaImageProps & HTMLAttributeClass
const props = withDefaults(defineProps<Props>(), {
  dividerMobile: 1,
  dividerTablet: 1,
  dividerDesktop: 1,
})

const imgRef = ref<HTMLImageElement | null>(null)

const {
  mobileSrc,
  tabletSrc,
  desktopSrc,
  mobileSrcset,
  tabletSrcset,
  desktopSrcset,
  imageUrl,
  isTabletAvailable,
  imageAlt,
} = useImage(props)
</script>

<template>
  <picture data-chromatic="ignore">
    <source
      v-if="mobileSrc"
      :srcset="mobileSrcset"
      media="(max-width: 639px)"
      type="image/webp"
    />

    <source
      v-else-if="tabletSrc"
      :srcset="tabletSrcset"
      media="(min-width: 640px) and (max-width: 959px)"
      type="image/webp"
    />

    <source
      v-else-if="desktopSrc"
      :srcset="desktopSrcset"
      :media="!isTabletAvailable ? '(min-width: 640px)' : '(min-width: 960px)'"
      type="image/webp"
    />
    <img
      ref="imgRef"
      :src="imageUrl"
      :alt="imageAlt"
      :loading="props.lazyload === 'lazy' ? 'lazy' : 'eager'"
      :fetchpriority="props.fetchpriority"
      :class="[
        {
          'h-full w-full object-cover': props.coverImage,
        },
        props.class,
      ]"
    />
  </picture>
</template>
